import { RootState } from '@src/redux/store'
import { prop } from 'ramda'
import { createSelector } from 'reselect'

import {
  GLOBAL_STATE,
  MODULE_FILE,
  MODULE_FILE_ALL,
  MODULE_FILE_CREATE,
  MODULE_FILE_DELETE,
  MODULE_FILE_LIST,
  POLICIES_ALL,
} from '../constants/actionTypes'

const moduleFilesSelector = (state: RootState) => prop(GLOBAL_STATE, state)

export const moduleFileListSelector = createSelector(moduleFilesSelector, data => data[MODULE_FILE_LIST])

export const policiesAllSelector = createSelector(moduleFilesSelector, data => data[POLICIES_ALL])

export const moduleFileAllSelector = createSelector(moduleFilesSelector, data => data[MODULE_FILE_ALL])

export const moduleFileSelector = createSelector(moduleFilesSelector, data => data[MODULE_FILE])

export const moduleFileCreateSelector = createSelector(moduleFilesSelector, data => data[MODULE_FILE_CREATE])

export const moduleFileDeleteSelector = createSelector(moduleFilesSelector, data => data[MODULE_FILE_DELETE])
